import React, { RefObject, useEffect, useRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addNewServiceStyle';
import { makeStyles } from '@material-ui/core';
import TabsWithDots, { ITab } from 'components/TabsWithDots/TabsWithDots';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleButton {
	color: types.theme.buttonColor;
	text: string;
	onClick: () => void;
	disabled?: boolean;
	ref?: boolean,
	id?: string;

}

interface IAddNewServiceProps {
	tabs: ITab[];
	activeTab: number;
	setActiveTab: React.Dispatch<React.SetStateAction<number>>;
	buttons: ISingleButton[];
	width?: number;
	setScrollToButton?: Function,
	scrollToButton?: boolean
}

const AddNewServiceWrapper = ({ tabs, activeTab, setActiveTab, buttons, width = 624,scrollToButton,setScrollToButton=()=>{} }: IAddNewServiceProps) => {
	const classes = useStyles();
	const navButtonsRef: RefObject<HTMLDivElement> = useRef(null);
	useEffect(()=>{
		if(navButtonsRef.current && scrollToButton){
			window.scrollTo({
				top: navButtonsRef.current.offsetTop,
				behavior: 'smooth',
			});
			setScrollToButton(false)
		}
	},[scrollToButton])
	return (
		<div className={classes.addNewServiceWrapper}>
			<TabsWithDots
				tabs={tabs}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				contentClasses={classes.contentWrapper}
				footer={
					<div className={classes.footer}>
						{buttons.map((button, index) => (
							<Button
								key={index}
								color={button.color}
								onClick={button.onClick}
								disabled={button.disabled}
								id={button.id}
								ref={button.ref ? navButtonsRef : null}
							>
								{button.text}
							</Button>
						))}
					</div>
				}
			/>
		</div>
	);
};

export default AddNewServiceWrapper;
